export default __webpack_public_path__ + "static/media/gallery_08.7557266a.jpg";